import { $t } from '@/plugins/i18n'
const Layout = () => import('@/layout/index.vue')

export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: $t('menus.hslogin'),
      showLink: false,
      rank: 101
    }
  },
  {
    path: '/redirect',
    component: Layout,
    meta: {
      icon: 'homeFilled',
      title: $t('menus.hshome'),
      showLink: false,
      rank: 102
    },
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/layout/redirect.vue'),
        meta: {}
      }
    ]
  },
  {
    path: '/error',
    redirect: '/error/403',
    component: Layout,
    meta: {
      icon: 'informationLine',
      title: 'menus.hsabnormal',
      showLink: false,
      rank: 9
    },
    children: [
      {
        path: '/error/403',
        name: '403',
        component: () => import('@/views/error/403.vue'),
        meta: {
          title: 'menus.hsfourZeroOne'
        }
      },
      {
        path: '/error/404',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: {
          title: $t('menus.hsfourZeroFour')
        }
      },
      {
        path: '/error/500',
        name: '500',
        component: () => import('@/views/error/500.vue'),
        meta: {
          title: $t('menus.hsFive')
        }
      }
    ]
  }
] as Array<RouteConfigsTable>
